import { PricingMode } from '@/lib/graphql/generated/graphql';
import { atom } from 'jotai';

export const pricingModeState = atom<PricingMode>(PricingMode.MarginFixed);
